import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useUpdateRenewalSetupByIdQuery = () => {
  const mutation = useMutation(async ({ id, ...dto }: { id: string; status: string | undefined }) =>
    api.patch(API_URL.RENEWALS_PLAN_YEAR_BY_PLAN_YEAR_ID(id), dto)
  );
  return mutation;
};

export default useUpdateRenewalSetupByIdQuery;
